var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsNewTag = function SvgTagsNewTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.172 3-9.584 9.586A1.98 1.98 0 0 0 2 14c0 .535.208 1.038.586 1.414l6.002 6c.378.377.879.586 1.412.586.535 0 1.038-.208 1.414-.586L21 11.828V3zM13 5h6v6l-9 9-6-6zm3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 9v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
  })));
};
export default SvgTagsNewTag;